import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { ReleaseComponent } from '../../../../../../types/releaseComponent';

type Props = {
  mode: '登録' | '更新';
  values: ReleaseComponent;
  handleClose: () => void;
};

export const ComponentRegistrationResultModalView: FC<Props> = ({
  mode,
  values,
  handleClose,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">コンポーネントの{mode}</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>コンポーネント名</FormLabel>
          <Input
            type="text"
            value={values.componentName}
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
        <FormLabel>顧客環境に適用したい情報の定義</FormLabel>
        <Stack pl="5">
          <FormControl>
            <FormLabel>管理場所</FormLabel>
            <Input
              type="text"
              value={values.repositoryUrl}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <FormLabel>顧客環境から収集したい情報の定義</FormLabel>
        <Stack pl="5">
          <FormControl>
            <FormLabel>マニフェストファイル名</FormLabel>
            <Input
              type="text"
              value={values.manifestName}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>必要なキー</FormLabel>
            {values.targetKeys?.map((targetKey, index) => (
              <Stack key={index.toString()}>
                <Input
                  type="text"
                  value={targetKey.value}
                  variant="flushed"
                  isReadOnly
                />
              </Stack>
            ))}
          </FormControl>
        </Stack>
      </Stack>
      <Text align="center" fontWeight="bold" mt="60px">
        {mode}が完了しました
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        variant="outline"
        onClick={handleClose}
      >
        閉じる
      </Button>
    </ModalFooter>
  </ModalContent>
);
